(() => {
  'use strict';
  const colors = [null,['#bc1024'],['#ed6b16'],['#e9b514'],['#168047'],['#33a8e7'],['#174990'],['#72339b'],['#f4f4ef'],['#48a5de','#153c89','#d12736'],['#1a1b1c','#c8262c','#ddb83d'],['#14934f','#f5f5f1','#d52b34']];
  const threads = [['#202126'],['#f5f5f1'],['#c92731'],['#e97920'],['#e6b31f'],['#17854d'],['#49a6dd'],['#1c4a93'],['#753e9c'],colors[9],colors[10],colors[11]];
  const id=(s,k,f='0')=>String(s[k]??f);
  function initialize(root) {
    if(root.dataset.modelProfile!=='adro-lci'||root.dataset.adroInitialized==='true')return;
    const viewer=root.querySelector('[data-scdwb-live-model]');
    if(!viewer)return;
    root.dataset.adroInitialized='true';
    const live=root.querySelector('[data-scdwb-live-panel]'),photos=root.querySelector('[data-scdwb-photo-panel]'),status=root.querySelector('[data-scdwb-live-status]');
    const copy=JSON.parse(root.querySelector('[data-adro-copy]').textContent);
    const gripFields=JSON.parse(root.querySelector('[data-scdwb-config]').textContent).catalog.fields;
    let assets={};try{assets=JSON.parse(root.dataset.assetMap||'{}');}catch{}
    assets['material-twill-0.jpg']='https://cdn.shopify.com/s/files/1/0679/0925/5230/files/scd-wheel-black-twill-original-weave-20260924.png?v=1790245261';
    const nonLedURL=new URL(viewer.getAttribute('src'),location.href).href;
    const ledURL=root.dataset.ledModelUrl?new URL(root.dataset.ledModelUrl,location.href).href:'';
    const cache=new Map(),scales=new Map();let revision=0;let originals=new Map();let activeURL=nonLedURL;
    const parts=name=>viewer.model.materials.filter(m=>m.name===name||m.name.startsWith(name+'.'));
    function url(key){
      const raw=assets['material-'+key]||assets[key];
      if(!raw)throw new Error('Missing material: '+key);
      const result=new URL(raw,location.href);
      if(result.protocol!=='https:'||!['cdn.shopify.com',location.hostname].includes(result.hostname))throw new Error('Invalid material URL');
      return result.href;
    }
    function texture(key){
      const source=url(key);
      if(!cache.has(source))cache.set(source,viewer.createTexture(source).then(t=>{t.sampler.setWrapS(10497);t.sampler.setWrapT(10497);scales.set(t,/^(twill|perf)-/.test(key)?4:1);return t;}).catch(error=>{cache.delete(source);throw error;}));
      return cache.get(source);
    }
    function surface(name,map,roughness,gloss,color='#ffffff',normal=false){
      const targets=parts(name);if(!targets.length)throw new Error('Missing wheel part: '+name);
      for(const target of targets){
        const pbr=target.pbrMetallicRoughness;
        pbr.baseColorTexture.setTexture(map);pbr.setBaseColorFactor(color);
        pbr.setRoughnessFactor(roughness);pbr.setMetallicFactor(gloss?.035:0);
        target.setClearcoatFactor?.(gloss?1:0);target.setClearcoatRoughnessFactor?.(.075);
        target.normalTexture?.setTexture(normal?originals.get(target.name)?.normal||null:null);
      }
    }
    function palette(prefix,palette){
      for(let i=0;i<3;i++)for(const mat of parts(prefix+i)){
        mat.pbrMetallicRoughness.setBaseColorFactor(palette[i%palette.length]);
        mat.pbrMetallicRoughness.setRoughnessFactor(.8);
      }
    }
    async function update(state){
      const request=++revision;
      delete root.dataset.previewReadyState;
      status.textContent=copy.updating;
      const desired=id(state,'led')==='1'?ledURL:nonLedURL;
      if(!desired){status.textContent=copy.unavailable;return;}
      if(activeURL!==desired){activeURL=desired;viewer.style.opacity='.35';viewer.src=desired;return;}
      if(!viewer.model||!viewer.loaded)return;
      try{
        const family=id(state,'carbon');
        const carbonKey=family==='1'?`forged-${id(state,'forged')}.jpg`:family==='2'?`honey-${id(state,'honey')}.jpg`:`twill-${id(state,'twill')}.jpg`;
        const match=id(state,'trim')==='1'&&id(state,'trimMaterial')==='carbon'&&id(state,'trimCarbonFinish')==='1';
        const trimKey=match?carbonKey:'twill-0.jpg';
        const material=id(state,'leather','1');
        const gripField=material==='2'?'alcColor':material==='0'?'smoothColor':'perfColor';
        const gripOption=gripFields.find(f=>f.id===gripField)?.options.find(o=>o.id===id(state,gripField));
        const gripKey=gripOption?.materialBase||(material==='2'?`alc-${id(state,'alcColor')}.jpg`:material==='0'?`smooth-${id(state,'smoothColor')}.jpg`:`perf-${id(state,'perfColor')}.jpg`);
        const [carbon,trim,black,grip,alcantara,leather]=await Promise.all([texture(carbonKey),texture(trimKey),texture('twill-0.jpg'),texture(gripKey),texture('alc-0.jpg'),texture('smooth-0.jpg')]);
        if(request!==revision||!viewer.loaded)return;
        surface('ADRO rim carbon',carbon,.17,true);
        surface('ADRO grip leather',grip,material==='2'?.95:.68,false,gripOption?.tint||'#ffffff',material==='1');
        const silver=id(state,'trim')==='1'&&id(state,'trimMaterial')==='silver';
        const trimMap=id(state,'trim')==='1'?trim:black;
        for(const name of ['ADRO button surround carbon','ADRO middle trim shell']){
          surface(name,silver?null:trimMap,silver?.28:.18,true,silver?'#bec2c7':'#ffffff');
          if(silver)for(const target of parts(name))target.pbrMetallicRoughness.setMetallicFactor(.8);
        }
        const stripe=colors[Number(id(state,'stripe','9'))];
        for(let i=0;i<3;i++)surface('ADRO top stripe '+i,stripe?null:carbon,.17,true,stripe?stripe[(2-i)%stripe.length]:'#ffffff');
        palette('ADRO grip stitching ',threads[Number(id(state,'stitch'))]||threads[0]);
        const customCover=id(state,'airbag')==='1';
        const suede=customCover&&id(state,'airbagMaterial')==='1';
        surface('ADRO airbag cover',suede?alcantara:leather,suede?.96:.75,false,'#ffffff',!suede);
        const stitch=id(state,'airbagStitch');
        palette('ADRO airbag stitching ',!customCover?threads[0]:stitch==='3'?threads[9]:stitch==='0'?threads[2]:stitch==='1'?threads[1]:threads[0]);
        for(const mat of parts('ADRO airbag stitching 1')){
          const visible=customCover&&stitch==='3';mat.setAlphaMode(visible?'OPAQUE':'BLEND');
          if(!visible)mat.pbrMetallicRoughness.setBaseColorFactor([0,0,0,0]);
        }
        for(const [map,scale] of scales)map.sampler.setScale({u:scale,v:scale});
        viewer.style.opacity='1';
        root.dataset.previewReadyState=JSON.stringify(state);
        root.dataset.adroActiveModel=id(state,'led')==='1'?'led':'non-led';
        status.textContent=copy.loaded;
        root.dispatchEvent(new CustomEvent('scdwb:preview-ready',{detail:{state:{...state}}}));
      }catch(error){if(request!==revision)return;viewer.style.opacity='1';status.textContent=copy.unavailable;console.error('ADRO swatches:',error);}
    }
    function show(mode){
      live.hidden=mode!=='3d';photos.hidden=mode==='3d';
      for(const button of root.querySelectorAll('[data-scdwb-view]')){const active=button.dataset.scdwbView===mode;button.setAttribute('aria-pressed',String(active));button.classList.toggle('scdwb-active',active);}
    }
    const fullscreen=root.querySelector('[data-scdwb-fullscreen]');
    if(fullscreen&&document.fullscreenEnabled&&live.requestFullscreen){
      fullscreen.hidden=false;
      fullscreen.addEventListener('click',async()=>{try{if(document.fullscreenElement===live)await document.exitFullscreen();else await live.requestFullscreen();}catch(error){console.warn(error);}});
      document.addEventListener('fullscreenchange',()=>{const active=document.fullscreenElement===live;fullscreen.setAttribute('aria-pressed',String(active));fullscreen.textContent=active?copy.exitFullscreen:copy.fullscreen;});
    }
    root.addEventListener('click',event=>{const button=event.target.closest('[data-scdwb-view]');if(button&&root.contains(button))show(button.dataset.scdwbView);});
    root.addEventListener('scdwb:selection',event=>update(event.detail.state));
    viewer.addEventListener('load',()=>{
      originals=new Map(viewer.model.materials.map(m=>[m.name,{normal:m.normalTexture?.texture}]));
      cache.clear();scales.clear();let state={};try{state=JSON.parse(root.dataset.wheelState||'{}');}catch{}
      update(state);
    });
    viewer.addEventListener('error',()=>{delete root.dataset.previewReadyState;status.textContent=copy.loadError;});
    show('3d');
    if(viewer.loaded){originals=new Map(viewer.model.materials.map(m=>[m.name,{normal:m.normalTexture?.texture}]));update(JSON.parse(root.dataset.wheelState||'{}'));}
  }
  const start=()=>document.querySelectorAll('scd-wheel-builder[data-model-profile="adro-lci"]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();


